// extracted by mini-css-extract-plugin
export default {"background":"Customers_background__QkFCZ","row":"Customers_row__VvnHT","col":"Customers_col__Rs-s8","card":"Customers_card__9cRse"};